var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingIcons = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8982_3290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.075 0H8.925L7.875 6.825H13.125M13.125 14.175H7.875L8.925 21H12.075",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0382 4.18909L16.8108 1.9617L11.2424 6.04524L14.9547 9.75755M9.75743 14.9548L6.04512 11.2425L1.96158 16.8109L4.18897 19.0383",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.075V8.925L14.175 7.875V13.125M6.825 13.125V7.875L0 8.925V12.075",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8109 19.0382L19.0383 16.8108L14.9548 11.2424L11.2424 14.9547M6.04521 9.75743L9.75752 6.04512L4.18906 1.96158L1.96167 4.18897",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.625C8.41142 2.625 6.40838 3.45469 4.93153 4.93153C3.45469 6.40838 2.625 8.41142 2.625 10.5C2.625 12.5886 3.45469 14.5916 4.93153 16.0685C6.40838 17.5453 8.41142 18.375 10.5 18.375C12.5886 18.375 14.5916 17.5453 16.0685 16.0685C17.5453 14.5916 18.375 12.5886 18.375 10.5C18.375 8.41142 17.5453 6.40838 16.0685 4.93153C14.5916 3.45469 12.5886 2.625 10.5 2.625V6.825C11.4747 6.825 12.4094 7.21219 13.0986 7.90138C13.7878 8.59058 14.175 9.52533 14.175 10.5C14.175 11.4747 13.7878 12.4094 13.0986 13.0986C12.4094 13.7878 11.4747 14.175 10.5 14.175C9.52533 14.175 8.59058 13.7878 7.90138 13.0986C7.21219 12.4094 6.825 11.4747 6.825 10.5C6.825 9.52533 7.21219 8.59058 7.90138 7.90138C8.59058 7.21219 9.52533 6.825 10.5 6.825",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8982_3290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingIcons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settingIcons.8f7c5bdfe70e7fad4750b9511ce54a8a.svg";